import React, { useState } from "react";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import Box from "@mui/material/Box";
import Courses from "./Courses";
import Dashboard from "./Dashboard";
import { APP_BAR_HEIGHT } from "../constants/layout";

export default function MainTabs() {
const [value, setValue] = useState(0);


return (
<Box sx={{height: `calc(100vh - ${APP_BAR_HEIGHT}px)`,mt: `${APP_BAR_HEIGHT}px`}}>
<Tabs value={value} onChange={(e, v) => setValue(v)} sx={{ mb: 3 }}>
<Tab label="Courses" />
<Tab label="Dashboard" />
</Tabs>
{value === 0 && <Courses />}
{value === 1 && <Dashboard />}
</Box>
);
}